import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';


const SuccessPage = () => {
    const navigate = useNavigate();

    const handleBack = () => {
        navigate('/uploads');
    };


    const handleGoHome = () => {
        navigate('/'); // Or your actual home route
    };

    const location = useLocation();
    const uploaded = location.state?.uploaded;


    return (
        <div className="hero-area10 header-background min-vh-100">
            <div style={styles.container}>
                {/* <div className = 'succes-sg-div' style={{ visibility : 'none' , marginLeft:'100px'}}>
                <h2 style={styles.heading}>Booking successful!!</h2>
                <p style={styles.message}>We’ve successfully received your documents.</p>
                <p style={styles.message}>✅ All steps are completed. We’ll get in touch with you shortly.</p>
                <p style={styles.message}>You can upload more documents or return to the home page below.</p>

                <div style={{ marginTop: '1.5rem' }}>
                    <button onClick={handleBack} style={styles.button}>
                        Upload Another Document
                    </button>
                    <button onClick={handleGoHome} style={{ ...styles.button, marginLeft: '1rem', backgroundColor: '#28a745' }}>
                        Go to Home
                    </button>
                </div>
            </div> */}
                <div style={styles.card}>
                    <h2 style={styles.heading}>Booking successful!!</h2>
                    {uploaded ? (
                        <>
                            <p style={styles.message}>🎉 Thank you! We've received your documents successfully.</p>
                            <p style={styles.message}>✅ All steps are complete. Our team will review your submission and reach out shortly if needed.</p>
                            <p style={styles.message}>You can upload additional documents or return to the home page using the options below.</p>
                        </>
                    ) : (
                        <>
                            <p style={styles.message}>✅ All steps are complete.</p>
                            <p style={styles.message}>You chose to skip document upload. But, you can upload them later. Our team will review your request and reach out if anything further is required.</p>
                            {/* <p style={styles.message}>Our team will review your request and reach out if anything further is required.</p> */}
                            <p style={styles.message}>You may now return to the home page.</p>
                        </>
                    )}
                    <div style={{ marginTop: '1.5rem'}}>
                        {uploaded ? (
                            <>
                                <button onClick={handleBack} style={styles.button }>
                                    Upload Another Document
                                </button>
                            </>
                        ) : null}


                        <button onClick={handleGoHome} style={{ ...styles.button, marginLeft: '1rem', backgroundColor: '#28a745' }}>
                            Go to Home
                        </button>
                    </div>
                </div>
            </div>
        </div>


    );
};

const styles = {
    container: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',

        padding: '1rem',
    },
    card: {
        backgroundColor: 'rgb(255, 255, 255)',
        // border: "2px solid rgb(0, 166, 255)",
        // color:"#fff",
        padding: '2rem',
        borderRadius: '12px',
        boxShadow: '0 6px 20px rgba(0, 0, 0, 0.25)',
        textAlign: 'center',
        maxWidth: '500px',
        width: '100%',
    },
    heading: {
        fontSize: '1.8rem',
        // color: '#fff',
        marginBottom: '1rem',
    },
    message: {
        fontSize: '1rem',
        // color: 'rgb(212 210 210)',
        marginBottom: '0.8rem',
    },
    button: {
        padding: '0.7rem 1.5rem',
        backgroundColor: '#007bff',
        color: '#fff',
        border: 'none',
        borderRadius: '6px',
        cursor: 'pointer',
        fontSize: '1rem',
        marginTop: '1rem',
    }
};


export default SuccessPage;
